import React from "react";
import {StepItem} from "./stepItem";
import "../tailwind.css";

export interface StepperProps {
  items: any[];
  current: number;
  currentStatus: "completed" | "wait" | "active";
  theme: string;
}

export const Stepper = ({
  current = 0,
  currentStatus = "active",
  items,
  theme = "falabella",
}: StepperProps) => {
  const nodes = items.map((item, index) => {
    let status = "wait";
    if (index === current) {
      status = currentStatus;
    } else if (index < current) {
      status = "completed";
    }
    return (
      <StepItem status={status} title={item} number={index + 1} key={index} />
    );
  });

  return <div className={`flex justify-between theme-${theme}`}>{nodes}</div>;
};
